import { Button, makeStyles, Typography } from "@material-ui/core";

import { MdErrorOutline } from "react-icons/md";

import ErrorPage from "../../components/ErrorPage";

import { coreRoutesConstants } from "modules/core/routes/routesConstants";

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.secondary.main
  },

  button: {
    display: "flex",
    justifyContent: "center",
    marginTop: 30
  }
}));

const Error500 = () => {
  const classes = useStyles();

  return (
    <ErrorPage
      icon={<MdErrorOutline className={classes.icon} size={64} />}
      title="Internal Error"
      content={
        <>
          <Typography variant="body1" align="center" gutterBottom>
            Something went wrong. We&apos;ve received a report about this
            issue...
          </Typography>

          <div className={classes.button}>
            <Button
              variant="contained"
              color="primary"
              component="a"
              href={coreRoutesConstants.dashboard.href("all")}
            >
              Go to dashboard
            </Button>
          </div>
        </>
      }
    />
  );
};

export default Error500;
